var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4955_54917)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.934 9.8519C26.8406 9.85085 25.7922 9.41602 25.019 8.64285C24.2459 7.86968 23.8111 6.82133 23.81 5.72791V0.00390625H5.38198C4.67504 0.0039062 3.97503 0.143174 3.32192 0.41377C2.66882 0.684365 2.07543 1.08098 1.57564 1.58096C1.07584 2.08093 0.679436 2.67448 0.409082 3.32769C0.138729 3.98089 -0.000262335 4.68097 3.71708e-07 5.38792V37.8299C-0.000262335 38.5368 0.138729 39.2369 0.409082 39.8901C0.679436 40.5433 1.07584 41.1369 1.57564 41.6368C2.07543 42.1368 2.66882 42.5334 3.32192 42.804C3.97503 43.0746 4.67504 43.2139 5.38198 43.2139H27.502C28.9299 43.2139 30.2994 42.6467 31.3091 41.637C32.3188 40.6273 32.886 39.2578 32.886 37.8299V9.85391L27.934 9.8519Z",
    fill: "#7741BA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.886 9.8519H27.934C26.8406 9.85084 25.7923 9.41602 25.0191 8.64285C24.2459 7.86968 23.8111 6.82133 23.8101 5.7279V0.00390625L32.886 9.8519Z",
    fill: "#7741BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7881 34.1239H11.7801C10.0061 34.1239 8.56812 35.562 8.56812 37.3359V44.7919C8.56812 46.5659 10.0061 48.0039 11.7801 48.0039H36.7881C38.562 48.0039 40.0001 46.5659 40.0001 44.7919V37.3359C40.0001 35.562 38.562 34.1239 36.7881 34.1239Z",
    fill: "#7741BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7259 42.6779V44.1339H15.22V42.6779H16.7259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7999 38.1199V39.2759H20.1679V44.1339H18.7039V39.2759H17.0879V38.1199H21.7999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.872 38.1199V44.1339H22.416V38.1199H23.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7999 38.1199V39.2759H26.3339V40.5939H28.2399V41.6999H26.3339V44.1339H24.8799V38.1199H28.7999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4659 38.1199V39.2759H30.9999V40.5939H32.9059V41.6999H30.9999V44.1339H29.5459V38.1199H33.4659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8619 29.2859H12.0259C11.1611 29.2849 10.332 28.9408 9.72051 28.3293C9.10899 27.7178 8.76497 26.8887 8.76392 26.0239V17.1899C8.76497 16.3251 9.10899 15.496 9.72051 14.8845C10.332 14.273 11.1611 13.929 12.0259 13.9279H20.8619C21.7262 13.9295 22.5546 14.2738 23.1653 14.8853C23.7761 15.4969 24.1194 16.3256 24.1199 17.1899V26.0239C24.1194 26.8882 23.7761 27.717 23.1653 28.3285C22.5546 28.94 21.7262 29.2843 20.8619 29.2859ZM12.0259 15.3699C11.5433 15.3704 11.0808 15.5624 10.7396 15.9036C10.3983 16.2448 10.2064 16.7074 10.2059 17.1899V26.0239C10.2064 26.5064 10.3983 26.9691 10.7396 27.3103C11.0808 27.6515 11.5433 27.8434 12.0259 27.8439H20.8619C21.3441 27.8428 21.8062 27.6507 22.147 27.3096C22.4877 26.9684 22.6794 26.5061 22.6799 26.0239V17.1899C22.6794 16.7077 22.4877 16.2454 22.147 15.9043C21.8062 15.5631 21.3441 15.371 20.8619 15.3699H12.0259Z",
    fill: "#7741BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4001 24.3439V26.0239C23.4001 26.6972 23.1327 27.343 22.6568 27.8193C22.1809 28.2955 21.5354 28.5634 20.8621 28.5639H12.0261C11.3524 28.5639 10.7064 28.2963 10.23 27.8199C9.75369 27.3436 9.48608 26.6975 9.48608 26.0239V23.2039C10.9001 22.8999 13.0541 22.8039 15.6701 23.8479L17.2881 22.3039L18.3921 25.1039C18.3921 25.1039 18.6881 24.0739 19.6441 24.2199C20.6001 24.3659 22.1481 24.8839 22.8101 24.4419C22.9885 24.339 23.1981 24.3042 23.4001 24.3439Z",
    fill: "#7741BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.308 18.9939C20.8503 18.9939 21.2899 18.5542 21.2899 18.0119C21.2899 17.4695 20.8503 17.0299 20.308 17.0299C19.7656 17.0299 19.3259 17.4695 19.3259 18.0119C19.3259 18.5542 19.7656 18.9939 20.308 18.9939Z",
    fill: "#7741BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4955_54917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 48,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiff);
export default __webpack_public_path__ + "static/media/tiff.dcb9e91ee50a1fbb2b83cde2fd1c8878.svg";
export { ForwardRef as ReactComponent };